import { useCallback } from 'react';
import {
    PosMicrosIntegrationMicros4700Outlet,
    PosMicrosIntegrationTransmissionProtocol,
} from '@mews-commander/data-access';
import { useDialogs } from '@mews-commander/ui';
import { IconButton, IconName, Stack } from '@optimus-web/core';
import { DELETE_MICROS_OUTLET_DIALOG_NAME, EDIT_MICROS_OUTLET_DIALOG_NAME } from '../constant';
import { DeleteMicrosOutletDialog } from './DeleteMicrosOutletDialog';
import { MicrosOutletFormDialog } from './MicrosOutletFormDialog';
import { useDetailedBillingConfigurationFlags } from './useDetailedBillingConfigurationFlags';

interface OutletTableActionProps {
    microsOutlet: PosMicrosIntegrationMicros4700Outlet;
    rowIndex: number;
    protocol: PosMicrosIntegrationTransmissionProtocol;
    formFormat?: string;
}

export const MicrosOutletTableDialogActions = ({
    microsOutlet,
    rowIndex,
    protocol,
    formFormat,
}: OutletTableActionProps) => {
    const { openDialog } = useDialogs();
    const { isDetailedBillingEnabled, isMultiDepartmentEnabled } = useDetailedBillingConfigurationFlags();

    const handleEditMicrosOutlet = useCallback(() => {
        openDialog(
            <MicrosOutletFormDialog
                microsOutlet={microsOutlet}
                isEditForm
                isDetailedBillingEnabled={isDetailedBillingEnabled}
                isMultiDepartmentEnabled={isMultiDepartmentEnabled}
                rowIndex={rowIndex}
                protocol={protocol}
                formFormat={formFormat}
            />,
            EDIT_MICROS_OUTLET_DIALOG_NAME
        );
    }, [isDetailedBillingEnabled, isMultiDepartmentEnabled, microsOutlet, openDialog, rowIndex, protocol, formFormat]);

    return (
        <Stack spacing="50">
            <IconButton
                variant="ghost"
                type="button"
                icon={IconName.Edit}
                onClick={handleEditMicrosOutlet}
                size="small"
            />
            <IconButton
                variant="ghost"
                type="button"
                icon={IconName.Delete}
                size="small"
                onClick={() =>
                    openDialog(<DeleteMicrosOutletDialog rowIndex={rowIndex} />, DELETE_MICROS_OUTLET_DIALOG_NAME)
                }
            />
        </Stack>
    );
};
